// @ts-nocheck
import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { auth } from '../firebase.js';
import RecipeCardSwipeable from './Shared/RecipeCards/RecipeCardSwipeable.tsx';
import fetchWithAuth from '../utils/fetchWithAuth.ts';
import { apiConfig } from '../config.js';
import BrandSpinner from './ui/atoms/BrandSpinner/BrandSpinner.tsx';
import AddToMealPlanSheet from './MealPlanner/AddToMealPlanSheet.tsx';
import { getCurrentWeekStart } from '../utils/getCurrentWeekStart.ts';
import {
  BookmarkIcon as BookmarkIconOutline,
} from '@heroicons/react/24/solid';
import ProfileEmptyState from '../components/EmptyStates/ProfileEmptyState.tsx';

const ProfileTabs = ({ profileId }) => {
  const currentUserId = auth.currentUser?.uid;
  const isOwnProfile = profileId === currentUserId;
  const navigate = useNavigate();
  const [tab, setTab] = useState(0); // 0 = Recipes, 1 = Saved
  const [recipes, setRecipes] = useState([]);
  const [savedRecipes, setSavedRecipes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [swipedRecipeId, setSwipedRecipeId] = useState(null);
  const [pickerOpen, setPickerOpen] = useState(false);
  const [pickerRecipe, setPickerRecipe] = useState(null);

  useEffect(() => {
    const fetchRecipes = async () => {
      setLoading(true);
      const response = await fetchWithAuth(`/api/users/${profileId}/recipes`);
      const data = await response;
      setRecipes(data);
      setLoading(false);
    };
    fetchRecipes();
  }, [profileId]);

  useEffect(() => {
    const fetchBookmarks = async () => {
      try {
        const response = await fetchWithAuth(
         `/api/bookmarks/user/${profileId}`
        );
        const data = await response;
        setSavedRecipes(data);
      } catch (err) {
        console.error('Error fetching bookmarks:', err.message);
      }
    };
    fetchBookmarks();
  }, [profileId]);

  const displayed = tab === 0 ? recipes : savedRecipes;

  const handleEdit = (recipeId: string) => {
    navigate(`/app/recipe/${recipeId}/edit`);
  };

  const handleDelete = async (recipeId: string) => {
    setRecipes((prev) => prev.filter((r) => r.id !== recipeId)); // optimistic UI update
    await fetchWithAuth(`/api/recipes/${recipeId}`, {
      method: 'DELETE',
    });
  };

  const openSheet = (r) => {
    setPickerRecipe(r);
    setPickerOpen(true);
  };

  return (
    <div className="mt-4 pb-10">
      {/* Tabs */}
      {/* <div className="flex border-b mb-4 sticky top-0 bg-white z-10"> */}
        <div
          className="sticky inset-x-0 bg-white border-b grid grid-cols-2 h-[40px] px-4 z-50 mb-2"
          style={{ top: 'var(--safe-top)' }}
        >
        <button
          onClick={() => setTab(0)}
          className={`flex-1 text-center py-2 text-sm font-medium border-b-2 ${
            tab === 0
              ? 'border-primary text-primary'
              : 'border-transparent text-gray-500 hover:text-gray-700'
          }`}
        >
          {recipes.length} Recipes
        </button>
        <button
          onClick={() => setTab(1)}
          className={`flex-1 text-center py-2 text-sm font-medium border-b-2 ${
            tab === 1
              ? 'border-primary text-primary'
              : 'border-transparent text-gray-500 hover:text-gray-700'
          }`}
        >
          {savedRecipes.length} Saved{' '}
          <BookmarkIconOutline className="inline-block w-5 h-5 text-gray-400" />
        </button>
      </div>

      {/* Results section */}
      {loading ? (
        <div className="text-center mt-10">
          <BrandSpinner />
        </div>
      ) : displayed.length === 0 ? (
        <div className="flex justify-center items-center min-h-[200px]">
          <ProfileEmptyState tab={tab}
            tab={tab}
            isOwnProfile={isOwnProfile}
          />
        </div>
      ) : (
        <div className="space-y-4">
          {displayed.map((r) => (
            <div onClick={() => setSwipedRecipeId(null)}>
              <RecipeCardSwipeable
                key={r.id}
                recipe={r}
                onEdit={isOwnProfile && tab === 0 ? handleEdit : null}
                onDelete={isOwnProfile && tab === 0 ? handleDelete : null}
                isSwiped={swipedRecipeId === r.id}
                onSwipe={() => setSwipedRecipeId(r.id)}
                onSwipeReset={() => setSwipedRecipeId(null)}
                swipeable={isOwnProfile && tab === 0}
                onAddToPlan={() => openSheet(r)}
              />
            </div>
          ))}
          {pickerRecipe && (
            <AddToMealPlanSheet
              isOpen={pickerOpen}
              onClose={() => setPickerOpen(false)}
              recipe={{
                id: pickerRecipe.id,
                title: pickerRecipe.title,
                imageUrl: pickerRecipe.imageUrl,
              }}
              weekStart={getCurrentWeekStart()}
              onAdded={() => {}}
            />
          )}
        </div>
      )}
    </div>
  );
};

export default ProfileTabs;
